/**********
 * Track *
 **********/
export const GLOBAL_UNWATCH = {
	action: 'watched',
	actionSubject: 'globalQuestions',
	attributes: {
		type: 'unwatch',
	},
};
export const GLOBAL_WATCH = {
	action: 'watched',
	actionSubject: 'globalQuestions',
	attributes: {
		type: 'watch',
	},
};
export const QUESTION_WATCH = {
	action: 'watched',
	actionSubject: 'singleQuestion',
	attributes: {
		type: 'watch',
	},
};
export const QUESTION_UNWATCH = {
	action: 'watched',
	actionSubject: 'singleQuestion',
	attributes: {
		type: 'unwatch',
	},
};
export const QUESTION_DELETE = {
	action: 'deleted',
	actionSubject: 'question',
};
export const ANSWER_ACCEPTED = {
	action: 'accepted',
	actionSubject: 'answer',
};
export const ANSWER_UNACCEPTED = {
	action: 'unaccepted',
	actionSubject: 'answer',
};
export const ANSWER_DELETE = {
	action: 'deleted',
	actionSubject: 'answer',
};
export const ANSWER_UPVOTE = {
	action: 'voted',
	actionSubject: 'answer',
	attributes: {
		type: 'upvoted',
	},
};
export const ANSWER_DOWNVOTE = {
	action: 'voted',
	actionSubject: 'answer',
	attributes: {
		type: 'downvoted',
	},
};
export const QUESTION_DOWNVOTE = {
	action: 'voted',
	actionSubject: 'question',
	attributes: {
		type: 'downvoted',
	},
};
export const QUESTION_UPVOTE = {
	action: 'voted',
	actionSubject: 'question',
	attributes: {
		type: 'upvoted',
	},
};
export const QUESTION_ADDCOMMENT = {
	action: 'added',
	actionSubject: 'questionComment',
};
export const COMMENT_DELETE = {
	action: 'deleted',
	actionSubject: 'comment',
};
export const ANSWER_ADDCOMMENT = {
	action: 'added',
	actionSubject: 'answerComment',
};
export const TOPIC_WATCH = {
	action: 'watched',
	actionSubject: 'topic',
	attributes: {
		type: 'watch',
	},
};
export const TOPIC_UNWATCH = {
	action: 'watched',
	actionSubject: 'topic',
	attributes: {
		type: 'unwatch',
	},
};

/**********
 * UI  *
 **********/
export const BSB_ASK_QUESTION = {
	action: 'clicked',
	actionSubject: 'button',
	actionSubjectId: 'CQAskQuestion',
};
export const BSB_CLICK_RESULT = {
	action: 'clicked',
	actionSubject: 'searchResult',
};
export const BSB_SEARCH = {
	action: 'clicked',
	actionSubject: 'searchField',
};
export const QUESTION_SHARECLICK = {
	action: 'clicked',
	actionSubject: 'button',
	actionSubjectId: 'CQShareQuestion',
};
export const QUESTIONLIST_TOPIC_LABEL_CLICK = {
	action: 'clicked',
	actionSubject: 'button',
	actionSubjectId: 'CQTopicLabel',
};

/**********
 * Screen  *
 **********/
export const PAGE_ADMIN = 'CQAdminScreen';
export const PAGE_EXPERT_LIST = 'CQExpertListScreen';
export const PAGE_QUESTION_ASK = 'CQAskQuestionScreen';
export const PAGE_QUESTION_EDIT = 'CQEditQuestionScreen';
export const PAGE_QUESTION_LIST_BY_TOPIC = 'CQQuestionListByTopicScreen';
export const PAGE_QUESTION_LIST_MACRO = 'CQMacroOnPageScreen';
export const PAGE_QUESTION_LIST = 'CQQuestionListScreen';
export const PAGE_QUESTION_VIEW = 'CQQuestionScreen';
export const PAGE_TOPIC_CREATE = 'CQCreateTopicScreen';
export const PAGE_TOPIC_EDIT = 'CQEditTopicScreen';
export const PAGE_TOPIC_LIST = 'CQTopicListScreen';
export const QUESTIONLIST_VIEW_POPULAR = 'CQQuestionListPopularScreen';
export const QUESTIONLIST_VIEW_RECENT = 'CQQuestionListRecentScreen';
export const QUESTIONLIST_VIEW_UNANSWERED = 'CQQuestionListUnansweredScreen';

/**********
 * Attributes  *
 **********/
export const SPACEPAGE_VIEW_ATTRIBUTE = 'space';
export const GLOBAL_PAGE_VIEW_ATTRIBUTE = 'globalPage';
